<template>
	<div>
		<StandardModal
			v-if="needsToUpdate"
			small
			open
			:title="$t('desktop_update_title')"
			:confirmText="$t('desktop_update_button')"
			:cancelText="$t('desktop_update_button_cancel')"
			@confirm="updateAndRestart"
			@cancel="onCancel"
			:confirmProps="{ loading: isLoading }"
		>
			<div class="alert-body">
				<GearsIcon halo />
				<div
					class="alert-title"
					v-text="
						$t('desktop_update_prompt_label', {
							Version: version,
						})
					"
				/>
				<div
					class="alert-text"
					v-text="
						$t('desktop_update_current_version', {
							Version: currentVersion,
						})
					"
				/>
			</div>
		</StandardModal>
	</div>
</template>
<script>
import { GearsIcon } from '@/icons'
import { StandardModal } from '@/components/common'
import { sleep, setLocalStorage } from '@/helpers/utils'
import { checkForAppUpdates, updateAppAndRestart } from '@/helpers/desktop'

export default {
	name: 'DesktopAppUpdateAlert',
	components: { StandardModal, GearsIcon },
	data() {
		return {
			needsToUpdate: false,
			currVersion: null,
			showAlert: null,
			isLoading: false,
		}
	},
	async mounted() {
		this.$onEventBus('app-visible', this.onVisibleChange)
		await sleep(3000)
		this.checkForUpdates()
	},
	methods: {
		async onVisibleChange(isVisible) {
			if (!isVisible || this.needsToUpdate) return
			this.checkForUpdates()
		},

		async checkForUpdates() {
			const {
				needsToUpdate,
				version,
				currentVersion,
			} = await checkForAppUpdates()

			if (needsToUpdate) {
				Object.assign(this, {
					needsToUpdate,
					version,
					currentVersion,
				})
			}
		},

		async updateAndRestart() {
			this.isLoading = true
			await updateAppAndRestart()
		},

		onCancel() {
			setLocalStorage('desktop_update_ignored', this.version)
			Object.assign(this, {
				needsToUpdate: false,
				version: null,
				currentVersion: null,
				isLoading: false,
			})
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.alert-body {
	@include flex-column-center;
	padding: 16px 40px;
	text-align: center;
	.pronto-icon {
		font-size: 55px;
		color: var(--blue-300);
		margin-bottom: 16px;
	}
	.alert-title {
		@include fontFamily(500);
		font-size: 18px;
		color: var(--text-gray-dark);
		margin-bottom: 8px;
	}
	.alert-text {
		@include fontFamily(500);
		font-size: 14px;
		color: var(--neutral-500);
	}
}
</style>
